import {Component, OnDestroy, ViewChild, computed, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActionDisabledComponent} from '@xmedical/ui';
import {DraftsService} from '../../../core/services/drafts.service';
import {Patient, ScriptType} from '@xmedical/core';
import {PatientScriptsStore, PatientStore} from '../../../core/state';

@Component({
    selector: 'app-patient-scripts-widget',
    templateUrl: './scripts-widget.component.html',
    styleUrls: ['./scripts-widget.component.scss'],
    standalone: false
})
export class ScriptsWidgetComponent implements OnDestroy {

  error = '';
  loading = false;
  @ViewChild(ActionDisabledComponent) disabledDialog: ActionDisabledComponent;
  private subscriptions: Subscription[] = [];

  private patientStore = inject(PatientStore);
  protected scriptsStore = inject(PatientScriptsStore);
  private draftService = inject(DraftsService);

  readonly scripts = computed(() => this.scriptsStore.items());

  get hasError(): boolean {
    return this.error.length > 0;
  }

  get hasScripts(): boolean {
    return this.scriptsStore.count() > 0;
  }

  get patient(): Patient | null {
    return this.patientStore.current();
  }

  get patientId(): number {
    return this.patientStore.current()?.id ?? 0;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  CreateCustomScript() {
    const patient = this.patientStore.current();
    if (!patient) return;
    this.subscriptions.push(this.scriptsStore.createDraft(ScriptType.ACUTE).subscribe({
      next: saved => {
        this.draftService.addNewDraft(patient.id, patient.profileId, patient.practiceId, 'script', saved, 'New Script');
      },
      error: error => console.error(error)
    }));
  }
}
